import { render, staticRenderFns } from "./MemberInvitation.vue?vue&type=template&id=20edb6ce&scoped=true"
import script from "./MemberInvitation.vue?vue&type=script&lang=js"
export * from "./MemberInvitation.vue?vue&type=script&lang=js"
import style0 from "./MemberInvitation.vue?vue&type=style&index=0&id=20edb6ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20edb6ce",
  null
  
)

export default component.exports